import http from '@/utils/http'

export function getCards(params){
    return  http('/getCards',{params})
}
export function getCardsUser(params){
    return  http('/getCardsUser',{params})
}
export function indexTitle(){
    return  http('/indexTitle')
}
export function getUserCardsRoleNum(){
    return  http('/getUserCardsRoleNum')
}
export function saveCardsUser(params){
    return  http.post('/saveCardsUser',params)
}
export function indexProperty(){
    return  http('/indexProperty')
}